module.exports = __webpack_public_path__ + "static/media/points.aabfad7f.svg";